import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  documentTypeId: z.string().optional(),
  customerId: z.string().optional(),
});

/**
 * @purpose Review workflow states
 * @primary States table
 * @persona danilo-tech
 */
export const Route = createFileRoute("/app/admin/fsm-workflows/states/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
